module.exports = __webpack_public_path__ + "res/19-img_media_bg.9902bf5226cc87e025ca8e5d390e04e2.png";